export class ROUTE_CONSTANTS {
  static readonly home = '';
  static readonly logout = 'logout';
  static readonly endOfSession = 'end-of-session';
  static readonly collectionNotice = 'collection-notice';
  static readonly integrityOfficer = {
    list: 'integrity-officer-list',
    prefix: 'integrity-officer',
    edit: 'integrity-officer/:id'
  } as const;
  static readonly referenceData = {
    list: 'reference-data-list',
    prefix: 'reference-data-detail',
    edit: 'reference-data-detail/:id'
  } as const;
  static readonly coiForm = {
    list: 'coi-form-list',
    prefix: 'coi-form',
    edit: 'coi-form/:id',
    viewPrefix: 'coi-form-view',
    view: 'coi-form-view/:id',
    externalPrefix: 'coi-form-external',
    externalEdit: 'coi-form-external/:id',
    externalViewPrefix: 'coi-form-view-external',
    externalView: 'coi-form-view-external/:id'
  } as const;
  static readonly approverCoiForm = {
    prefix: 'approver-coi-form',
    edit: 'approver-coi-form/:id',
    viewPrefix: 'approver-coi-form-view',
    view: 'approver-coi-form-view/:id'
  } as const;
  static readonly dopiForm = {
    list: 'dopi-form-list',
    prefix: 'dopi-form',
    edit: 'dopi-form/:id',
    viewPrefix: 'dopi-form-view',
    view: 'dopi-form-view/:id',
    externalPrefix: 'dopi-form-external',
    externalEdit: 'dopi-form-external/:id',
    externalViewPrefix: 'dopi-form-view-external',
    externalView: 'dopi-form-view-external/:id'
  } as const;
  static readonly approverDopiForm = {
    prefix: 'approver-dopi-form',
    edit: 'approver-dopi-form/:id',
    viewPrefix: 'approver-dopi-form-view',
    view: 'approver-dopi-form-view/:id'
  } as const;
  static readonly gbhForm = {
    list: 'gbh-form-list',
    prefix: 'gbh-form',
    edit: 'gbh-form/:id',
    viewPrefix: 'gbh-form-view',
    view: 'gbh-form-view/:id'
  } as const;
  static readonly approverGbhForm = {
    prefix: 'approver-gbh-form',
    edit: 'approver-gbh-form/:id',
    viewPrefix: 'approver-gbh-form-view',
    view: 'approver-gbh-form-view/:id'
  } as const;
};
